import { useContext, useReducer, createContext, useCallback } from "react";
import { useRequest } from "../../services/request";

const Context = createContext();

export function useNFC() {
  return useContext(Context);
}

const initState = {
  list: [],
  employeesNFCList: [],
  ticketNFCList: [],
  memberShipList: [],
  selected: null,
  filters: null,
  count: 1,
  page: 1,
  perPage: 10,
  length: 0,
  countEmp: 1,
  pageEmp: 1,
  perPageEmp: 10,
  lengthEmp: 0,
  countTick: 1,
  pageTick: 1,
  perPageTick: 10,
  lengthTick: 0,
  countMemberShip: 1,
  pageMemberShip: 1,
  perPageMemberShip: 10,
  lengthMemberShip: 0,
  status: "idle",
  error: null,
};
const reducer = (state, action) => {
  switch (action.type) {
    case "set_list":
      return { ...state, list: [...action.payload] };
    case "set_employeesNFCList":
      return { ...state, employeesNFCList: [...action.payload] };
    case "set_ticketNFCList":
      return { ...state, ticketNFCList: [...action.payload] };

    case "set_MemberShipNFC":
      return { ...state, memberShipList: [...action.payload] };
    case "set_selected":
      return { ...state, selected: { ...action.payload } };
    case "set_filters":
      return { ...state, filters: { ...action.payload } };
    case "set_count":
      return { ...state, count: action.payload };
    case "set_countEmp":
      return { ...state, countEmp: action.payload };
    case "set_countTick":
      return { ...state, countTick: action.payload };
    case "set_countMemberShip":
      return { ...state, countMemberShip: action.payload };
    case "add":
      const newList = [{ ...action.payload }, ...state.list];
      return { ...state, list: newList };
    case "edit":
      const modified = state.list.map((p) =>
        p.id === action.payload.id ? { ...p, ...action.payload } : p
      );
      return { ...state, list: modified };
    case "delete":
      const filtered = state.list.filter((p) => p.tag.id !== action.payload);
      return { ...state, list: filtered };
    case "deleteTag":
      const filteredTag = state.list.filter((p) => p.id !== action.payload);
      return { ...state, list: filteredTag };
    case "status":
      return { ...state, status: action.payload };
    case "set_page":
      return { ...state, page: action.payload };
    case "set_per_page":
      return { ...state, perPage: action.payload };
    case "set_length":
      return { ...state, length: action.payload };

    case "set_pageEmp":
      return { ...state, pageEmp: action.payload };
    case "set_per_pageEmp":
      return { ...state, perPageEmp: action.payload };
    case "set_lengthEmp":
      return { ...state, lengthEmp: action.payload };

    case "set_pageTick":
      return { ...state, pageTick: action.payload };
    case "set_per_pageTick":
      return { ...state, perPageTick: action.payload };
    case "set_lengthTick":
      return { ...state, lengthTick: action.payload };

    case "set_pageMemberShip":
      return { ...state, pageMemberShip: action.payload };
    case "set_per_page_MemberShip":
      return { ...state, perPageMemberShip: action.payload };
    case "set_length_MemberShip":
      return { ...state, lengthMemberShip: action.payload };
    default:
      throw new Error(`Invalid dispatch type: ${action.type}`);
  }
};

export default function NFCProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initState);
  const req = useRequest();
  const fetchList = useCallback(
    async (companyId, page, perPage) => {
      dispatch({ type: "status", payload: "fetching" });
      let headersData = {
        pageNumber: page,
      };
      if (perPage) headersData.pageSize = perPage;

      const resData = await req(
        `Tag/List/${companyId}`,
        null,
        {},
        true,
        headersData
      );
      dispatch({ type: "status", payload: `idle` });
      dispatch({ type: "set_list", payload: resData.data.tags || [] });
      dispatch({ type: "set_per_page", payload: resData.data.pageSize });
      dispatch({ type: "set_count", payload: resData.data.totalPages });
      dispatch({ type: "set_length", payload: resData.data.totalSize });
    },
    [req]
  );

  /**delete NFC */
  const remove = useCallback(
    async (NFcid, name) => {
      return new Promise(async (resolve, reject) => {
        dispatch({ type: "status", payload: `deleting` });
        try {
          const resData = await req(
            `Tag/Remove/${NFcid}`,
            {},
            { method: "DELETE" },
            true
          );

          if (name === "General") {
            dispatch({ type: "deleteTag", payload: NFcid });
          } else {
            dispatch({ type: "delete", payload: NFcid });
          }
          resolve(resData);
        } catch (e) {
          reject(e);
        } finally {
          dispatch({ type: "status", payload: `idle` });
        }
      });
    },
    [req]
  );
  /** fetch employees nfc list */

  const fetchEmpNFCList = useCallback(
    async (companyId, page, perPage) => {
      dispatch({ type: "status", payload: "fetching" });
      let headersData = {
        pageNumber: page,
      };
      if (perPage) headersData.pageSize = perPage;

      const resData = await req(
        `Tag/EmployeeTagList/${companyId}`,
        null,
        {},
        true,
        headersData
      );
      dispatch({ type: "status", payload: `idle` });
      dispatch({
        type: "set_employeesNFCList",
        payload: resData.data.employees || [],
      });
      dispatch({ type: "set_per_pageEmp", payload: resData.data.pageSize });
      dispatch({ type: "set_countEmp", payload: resData.data.totalPages });
      dispatch({ type: "set_lengthEmp", payload: resData.data.totalSize });
    },
    [req]
  );

  /*fetch ticket nfc */
  const fetchTicketNFCList = useCallback(
    async (siteId, page, perPage) => {
      dispatch({ type: "status", payload: "fetching" });
      let headersData = {
        pageNumber: page,
      };
      if (perPage) headersData.pageSize = perPage;

      const resData = await req(
        `Tag/TicketList/${siteId}`,
        null,
        {},
        true,
        headersData
      );
      dispatch({ type: "status", payload: `idle` });
      dispatch({
        type: "set_ticketNFCList",
        payload: resData.data?.tickets || [],
      });
      dispatch({ type: "set_per_pageTick", payload: resData.data?.pageSize });
      dispatch({ type: "set_countTick", payload: resData.data?.totalPages });
      dispatch({ type: "set_lengthTick", payload: resData.data?.totalSize });
    },
    [req]
  );

  /*fetch member ship nfc */
  const fetchMemberShipNFCList = useCallback(
    async (id, pid, page, perPage) => {
      dispatch({ type: "status", payload: "fetching" });
      let headersData = {
        pageNumber: page,
      };
      if (perPage) headersData.pageSize = perPage;

      const resData = await req(
        `Tag/MemberTagList/${id}, ${pid}`,
        null,
        {},
        true,
        headersData
      );
      dispatch({ type: "status", payload: `idle` });
      dispatch({
        type: "set_MemberShipNFC",
        payload: resData.data.members || [],
      });
      dispatch({
        type: "set_per_page_MemberShip",
        payload: resData.data.pageSize,
      });
      dispatch({
        type: "set_countMemberShip",
        payload: resData.data.totalPages,
      });
      dispatch({
        type: "set_length_MemberShip",
        payload: resData.data.totalSize,
      });
    },
    [req]
  );

  return (
    <Context.Provider
      value={{
        state,
        dispatch,
        fetchList,
        remove,
        fetchEmpNFCList,
        fetchTicketNFCList,
        fetchMemberShipNFCList,
      }}
    >
      {children}
    </Context.Provider>
  );
}
